import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compact from 'lodash/compact';
import classnames from 'classnames';
import PlanDisclaimer from 'shared/lib/components/PlanDisclaimer';
import CreditCardLogos from 'shared/lib/components/CreditCardLogos';
import iconPolicy from './icon-policy.png';
import './TrustSymbols.css';

const propTypes = {
  verticalName: PropTypes.string,
  protectionList: PropTypes.array.isRequired,
  activeLink: PropTypes.string,
  disclaimer: PropTypes.string.isRequired,
};

class TrustSymbols extends PureComponent {
  state = {
    verticalName:
      this.props.verticalName || compact(this.props.activeLink.split('/'))[0],
  };

  renderProtectionList = (itemText, i) => (
    <li className="TrustSymbols-coverage-list-item" key={`${i}_${itemText}`}>
      <div className="TrustSymbols-coverage-list-icon fas fa-check" />
      <p className="TrustSymbols-coverage-list-text">{itemText}</p>
    </li>
  );

  render() {
    return (
      <div className={classnames(this.props.className, 'TrustSymbols')}>
        <div className="TrustSymbols-heading">
          <img
            className="TrustSymbols-heading-icon"
            src={iconPolicy}
            alt="Policy Icon"
          />
          <h1 className="TrustSymbols-heading-text">
            Let's find you the best {this.state.verticalName} policy.
          </h1>
        </div>
        <div className="TrustSymbols-coverage-list">
          <div className="TrustSymbols-coverage-list-wrapper">
            <div className="TrustSymbols-coverage-list-heading">
              Your coverage protects against:
            </div>
            <ul className="TrustSymbols-coverage-list-ul">
              {this.props.protectionList.map(this.renderProtectionList)}
            </ul>
          </div>
        </div>
        <div className="TrustSymbols-wrapper">
          <div className="TrustSymbols-testimonial">
            <p className="TrustSymbols-testimonial-stars fas">
              &#xf005; &#xf005; &#xf005; &#xf005; &#xf005;
            </p>
            <p className="TrustSymbols-testimonial-quote">
              “I have never had a better customer service experience with an
              insurance company. I was expecting a drawn out process and lots of
              paperwork and was pleasantly surprised by your employees.”
            </p>
            <p className="TrustSymbols-testimonial-attribution">
              Jessica M. <br />
              Santa Monica, CA
            </p>
          </div>
          <CreditCardLogos />
          <PlanDisclaimer
            text={this.props.disclaimer}
            lineBreakOnSentence
            showBuiltOnLogo={!!this.props.partnerInfo}
          />
        </div>
      </div>
    );
  }
}

TrustSymbols.propTypes = propTypes;

export default TrustSymbols;
